<template>
<body class="body-4">
  <div class="side-navigation">
    <div @click="gotoHome()"><img src="../../../assets/images/Logo---White2x.png" width="170" alt="" class="image-logo-home"></div>
    <div>
      <div class="nav">
        <router-link to="/" class="heading-3">Home</router-link>
        <router-link to="/shop" class="heading-3">Shop</router-link>
        <router-link to="/dashboard" class="heading-3 active w--current">Account</router-link>
      </div>
      <h1 class="shop-header">Account</h1>
    </div>
  </div>
  <div class="dashboard shop-content">
    <div class="top-mobile-nav-bar">
      <div class="wrap _w-custom nav1-dark">
        <div data-collapse="medium" data-animation="over-left" data-duration="400" data-no-scroll="1" class="nav1 w-nav">
          <div class="mobile-nav-wrap mobile-shop">
            <div class="nav1-logo-wrapper">
              <router-link to="/" class="w-inline-block"><img src="../../../assets/images/Logo---White2x.png" width="102" alt="" class="image-7"></router-link>
            </div>
            <div @click="mixNav()" class="navmenubutton shop w-nav-button">
              <div class="burger-1">
                <div class="b1-bar1-2"></div>
                <div class="b1-bar2-2">
                  <div class="b1-middle-2"></div>
                </div>
                <div class="b1-bar3-2"></div>
              </div><img src="../../../assets/images/menu-icon2x_1menu-icon@2x.png" width="18" alt="" class="nav1-menu-icon-2">
            </div>
            <nav v-show="showNav" role="navigation" class="nav1-menu-wrapper-dark-2 w-nav-menu">
              <div class="return-arrow shop">
                <a @click="mixNav()" href="#" class="link-8 w--current">
                  <strong class="bold-text-2"></strong>
                </a>
              </div>
              <div class="container-5 w-container">
                <!-- <a href="https://supremeaccess.io" class="link-dark navigation1-link-dark shop">Home</a> -->
                <a href="/#/shop" class="link-dark navigation1-link-dark shop">Shop</a>
                <a href="/#/dashboard" class="link-dark navigation1-link-dark shop shop-2 w--current">Dashboard</a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div data-duration-in="300" data-duration-out="100" class="tabs w-tabs">
      <div class="dashboard-menu w-tab-menu">
        <!-- <a data-w-tab="Tab 1" class="tab-link-tab-1 w-inline-block w-tab-link">
          <div class="tab-link">Account Info</div>
        </a> -->
        <!-- <a data-w-tab="Tab 2" class="tab-link-tab-2 w-inline-block w-tab-link">
          <div class="tab-link-2">Personas</div>
        </a> -->
        <a data-w-tab="Tab 3" class="tab-link-tab-3 w-inline-block w-tab-link w--current">
          <div class="tab-link-3">Orders</div>
        </a>
        <a data-w-tab="Tab 4" ms-profile="true" class="tab-link-tab-4 w-inline-block w-tab-link">
          <div @click="$router.push('/logout')" class="tab-link-4">Sign Out</div>
        </a>
      </div>
      <div class="dash-tab-wrapper w-tab-content">
        <div data-w-tab="Tab 1" class="account-info w-tab-pane">
          <div class="columns-3 w-row">
            <div ms-update="profile" class="column-5 w-col w-col-6">
              <div class="w-form">
                <h1 class="heading-24">User Details</h1>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div class="column-6 w-col w-col-6">
              <div class="w-form">
                <h1 class="heading-24">Payment/Billing</h1>
                <form id="email-form" name="email-form" data-name="Email Form" ms-update="profile" class="form-4"><label for="Address" class="field-label-2">Address</label><input type="text" class="text-field-5 w-input" maxlength="256" name="Address"
                    data-name="Address" placeholder="123 Fake Street" ms-field="address" id="Address"><label for="City" class="field-label-3">City</label><input type="email" class="text-field-6 w-input" maxlength="256" name="City" data-name="City"
                    placeholder="New York" id="City" required=""><label for="State" class="field-label-3">State</label><input type="email" class="text-field-7 w-input" maxlength="256" name="State" data-name="State" placeholder="NY" id="State"
                    required=""><label for="Zip-Code" class="field-label-3">Zip Code</label><input type="email" class="text-field-8 w-input" maxlength="256" name="Zip-Code" data-name="Zip Code" placeholder="28592" id="Zip-Code" required=""><label
                    for="Credit-Card" class="field-label-3">Credit Card</label>
                  <div class="text-block-49">Visa</div><input type="email" class="text-field-8 w-input" maxlength="256" name="Credit-Card" data-name="Credit Card" placeholder="**** **** **** 4921" id="Credit-Card" required="">
                </form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div data-w-tab="Tab 2" class="personas w-tab-pane">
          <h1 class="heading-25">Main Account</h1>
          <div class="product-column w-row">
            <div class="column-7 w-col w-col-4">
              <div class="w-form">
                <form id="email-form-2" name="email-form-2" data-name="Email Form 2" class="form">
                  <label for="Full-Name" class="field-label-4">Full Name</label><input type="text" class="text-field-9 w-input" maxlength="256" name="Full-Name" data-name="Full Name" placeholder="John Doe" id="Full-Name"><label for="Phone-Number-2"
                    class="field-label-5">Phone Number</label><input type="email" class="text-field-10 w-input" maxlength="256" name="Phone-Number" data-name="Phone Number" placeholder="1233 - 456 -7890" id="Phone-Number-2" required=""><label
                    for="email-3" class="field-label-5">Email</label><input type="email" class="text-field-11 w-input" maxlength="256" name="email-3" data-name="Email 3" placeholder="johndoe@gmail.com" id="email-3" required=""></form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div class="column-8 w-col w-col-4">
              <div class="w-form">
                <form id="email-form-3" name="email-form-3" data-name="Email Form 3" class="form-2">
                  <label for="name-3" class="field-label-7">Address</label><input type="text" class="text-field-12 w-input" maxlength="256" name="name-3" data-name="Name 3" placeholder="123 Fake Street" id="name-3"><label for="email-6"
                    class="field-label-6">City</label><input type="email" class="text-field-13 w-input" maxlength="256" name="email-4" data-name="Email 4" placeholder="New York" id="email-4" required=""><label for="email-4"
                    class="field-label-6">State</label><input type="email" class="text-field-14 w-input" maxlength="256" name="email-4" data-name="Email 4" placeholder="NY" id="email-4" required=""></form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
            <div class="column-9 w-col w-col-4">
              <div class="w-form">
                <form id="email-form-4" name="email-form-4" data-name="Email Form 4" class="form-5">
                  <label for="name-4" class="field-label-8">Credit Card</label><input type="text" class="text-field-15 w-input" maxlength="256" name="name-4" data-name="Name 4" placeholder="28592" id="name-4"><label for="email-6"
                    class="field-label-9">Credit Card</label>
                  <div class="text-block-50">Visa</div><input type="email" class="text-field-16 w-input" maxlength="256" name="email-5" data-name="Email 5" placeholder="**** **** ****4921" id="email-5" required="">
                </form>
                <div class="w-form-done">
                  <div>Thank you! Your submission has been received!</div>
                </div>
                <div class="w-form-fail">
                  <div>Oops! Something went wrong while submitting the form.</div>
                </div>
              </div>
            </div>
          </div>
          <div class="div-block-22"></div>
        </div>
        <b-container>
          <h1 class="heading-26">My Orders</h1>
          <!-- <div class="text-block-33">Orders</div> -->
          <!-- <div class="container-9 w-container"><a href="#" class="test-order w-button">Test Order</a><a href="#" class="test-order check-out w-button">Test Check Out</a><a href="#" class="export-visiible w-button">Export Visible</a></div> -->
          <!-- <div class="div-block-28"></div> -->
          <b-table hover :items="modOrders" :fields="fields" style="font-family: Roboto, sans-serif; color: #fff;">
          </b-table>
        </b-container>
      </div>
    </div>
  </div>


</body>
</template>
<script>
import {
  userService
} from '@/services/user'
export default {
  name: 'dashboard',
  data() {
    return {
      showNav: false,
      fields: [
        'orderId',
        'productTitle',
        'size',
        'style',
        'price',
        'status',
      ],
      orders: [],
      userInfo: {},
      testOrders: [{
        'orderId': '123',
        'productTitle': 'box logo',
        'status': 'pending',
        'size': '7',
        'price': '55'
      }]

    }
  },
  computed: {
    modOrders() {
      let upperSize = this.orders.map(function(o) {
        o.size = o.size.toUpperCase()
        return o
      })
      for (let i=0; i < upperSize.length;i++) {
        if(upperSize[i].style == 'os') {
          upperSize[i].style = 'OS'
        }
      }
      return upperSize
    }
  },
  created() {
    // return
    userService.userInfo()
      .then((resp) => {
        this.userInfo = resp
      })
      .catch(console.errror)
    userService.getOrders()
      .then((resp) => {
        this.orders = resp
      })
      .catch(console.error)

    // this.$store.dispatch('auth/fetchUser') // make sure user jwt token is valid
  },
  methods: {
    gotoHome() {
      if (this.$route.path != '/' && this.$route.path != '/shop') this.$router.push('/')
    },
    mixNav() {
      this.showNav = !this.showNav
    },

  }

}
</script>
